import { useTranslation } from 'next-i18next';
import { clsx } from 'clsx';
import { InformationCircleIcon } from '@heroicons/react/24/solid';
import { Card } from '@components/common';
import { cardStyles } from './helpers/cardStyles';

// Interface
// ******************************************
export interface EmptyJobListProps {
  title?: string;
  className?: string;
}

/**
 * @description EmptyJobList Component. A component to be displayed when no jobs are found.
 *
 * - **title**: string - the title of the job list, containing the current filter labels.
 * - **className**: string - additional CSS classes to apply for styling purposes.
 */
export const EmptyJobList = (props: EmptyJobListProps) => {
  // Destructure props
  const { title, className } = props;

  // Translation
  const { t } = useTranslation('common');

  // Render component
  // *****************************************************
  return (
    <Card className={clsx(cardStyles, className)}>
      <Card.Body className="!py-14 text-center">
        <div className="text-center">
          <p className="mb-0 font-semibold leading-loose">
            { t('job.list.no_result.title') }
          </p>
          {title && (<p>{title}</p>)}
        </div>
        <hr className="my-8" />
        <div className="flex flex-col items-center">
          <div className="mb-4 flex items-center justify-center">
            <InformationCircleIcon className="mr-2 size-6 text-info" />
            { t('job.list.recommendation.search') }
          </div>
          <ul className="ml-10 list-disc space-y-0.5 text-left text-sm text-ink-medium">
            <li>{ t('job.list.correct.keyword') }</li>
            <li>{ t('job.list.general.keyword') }</li>
            <li>{ t('job.list.abbreviations.keyword') }</li>
          </ul>
        </div>
      </Card.Body>
    </Card>
  );
};

